document.addEventListener(
  "DOMContentLoaded",
  function () {
    let elements = document.querySelectorAll('[data-animation="fade-in"]');

    const observerOptions = {
      root: null,
      threshold: 0,
      rootMargin: "0px 0px -15% 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let delay = (entry.target.dataset.delay ?? 0) * 1000;
          setTimeout(() => {
            entry.target.classList.add("faded");
          }, delay);
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    for (let element of elements) {
      observer.observe(element);
    }
  },
  false
);

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    const swiperEl = this.querySelector('.swiper');

    const swiper = new Swiper(swiperEl, {
      autoplay: {
        delay: 5000,
      },
      speed: 500,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
    });
  }
}

window.customElements.define('announcement-bar', AnnouncementBar);
class BlogPosts extends HTMLElement {
  constructor() {
    super();

    const swiperEl = this.querySelector(".swiper");

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 2.3,
      spaceBetween: 10,
      breakpoints: {
        600: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

window.customElements.define("blog-posts-component", BlogPosts);

class Collections extends HTMLElement {
  constructor() {
    super();

    const swiperEl = this.querySelector(".swiper");

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      breakpoints: {
        600: {
          slidesPerView: 2.2,
        },
        800: {
          slidesPerView: 3.2,
        },
        1000: {
          slidesPerView: 4,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
      },
    });
  }
}

window.customElements.define("collections-component", Collections);

class DrawerNote extends HTMLElement {
  constructor() {
    super();

    let checkbox = document.querySelector("#cart-note-checkbox");
    let note = document.querySelector(".cart__note");

    checkbox.addEventListener("change", (e) => {
      if (e.target.checked) {
        note.style.display = "block";
      } else {
        note.style.display = "none";
      }
    });
  }
}

window.customElements.define("drawer-note", DrawerNote);

class SelectDropdown extends HTMLElement {
  constructor() {
    super();

    let selects = this.querySelectorAll("select.facet-filters__sort");

    [...selects].forEach((select) => {
      let label = document.querySelector(".sort-label");
      let span = document.querySelector(".sort-label");
      let parent = label.parentNode;
      let svg = this.querySelector(".select-icon");

      let labelText = span.innerText;

      let el = document.createElement("div");
      el.classList.add("dropdown");

      let labelEl = document.createElement("span");
      labelEl.classList.add("dropdown__label");
      labelEl.innerText = labelText;
      labelEl.appendChild(svg);

      let dropdownEl = document.createElement("div");
      dropdownEl.classList.add("dropdown__list");

      let options = select.querySelectorAll("option");

      [...options].forEach((option) => {
        let optionEl = document.createElement("span");
        optionEl.classList.add("dropdown__item");
        optionEl.innerText = option.innerText;
        optionEl.value = option.value;

        optionEl.addEventListener("click", () => {
          // labelEl.innerText = optionEl.innerText;
          select.value = optionEl.value;
          el.classList.remove("active");
          labelEl.classList.remove("active");
          dropdownEl.classList.remove("active");

          if (select.value !== "") {
            labelEl.classList.add("has-value");
          } else {
            labelEl.classList.remove("has-value");
          }

          select.dispatchEvent(new Event("change"));
        });

        dropdownEl.appendChild(optionEl);
      });

      el.appendChild(labelEl);
      el.appendChild(dropdownEl);

      parent.appendChild(el);

      labelEl.addEventListener("click", () => {
        el.classList.toggle("active");
        labelEl.classList.toggle("active");
        dropdownEl.classList.toggle("active");
      });

      window.addEventListener("click", ({ target }) => {
        const dropdownList = target.closest(".dropdown");
        let openDropdowns = document.querySelectorAll(".dropdown.active");

        if (!dropdownList && openDropdowns.length > 0) {
          [...openDropdowns].forEach((dropdown) => {
            dropdown.classList.remove("active");
            dropdown
              .querySelector(".dropdown__label")
              .classList.remove("active");
            dropdown
              .querySelector(".dropdown__list")
              .classList.remove("active");
          });
        }
      });
    });
  }
}

window.customElements.define("select-dropdown", SelectDropdown);

class FeaturedProducts extends HTMLElement {
  constructor() {
    super();

    const swiperComponent = this.querySelector(".swiper-component");
    const swiperEl = this.querySelector(".swiper");

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      navigation: {
        nextEl: swiperComponent.querySelector(".swiper-button-next"),
        prevEl: swiperComponent.querySelector(".swiper-button-prev"),
      },
    });
  }
}

window.customElements.define("featured-products-component", FeaturedProducts);

class Header extends HTMLElement {
  constructor() {
    super();

    let lastScroll = 0;
    const header = this;
    const menuButton = this.querySelector(".menu-button");
    const closeButton = this.querySelector(".close-button");
    const body = document.querySelector("body");
    const arrows = this.querySelectorAll(".submenu-button");
    const parentItems = this.querySelectorAll(".has-child");
    const parentLinks = this.querySelectorAll(".has-child > a");
    const headerGroup = document.querySelector(".header-group");
    const main = document.querySelector("#MainContent");
    const pageSidebar = document.querySelector(".page__sidebar");
    let headerHeight = headerGroup.offsetHeight;

    main.style.paddingTop = headerHeight + "px";

    if (pageSidebar) {
      pageSidebar.style.top = headerHeight - 80 + "px";
    }

    if (window.innerWidth <= 900) {
      [...arrows].forEach((arrow) => {
        arrow.addEventListener("click", (e) => {
          e.preventDefault();
          let item = arrow.parentElement;
          item.classList.toggle("submenu-open");
        });
      });

      [...parentLinks].forEach((parentLink) => {
        parentLink.addEventListener("click", (e) => {
          e.preventDefault();
          let item = parentLink.parentElement;
          item.classList.toggle("submenu-open");
        });
      });
    }

    menuButton.addEventListener("click", () => {
      header.classList.add("menu-open");
      body.classList.add("menu-open");
    });

    closeButton.addEventListener("click", () => {
      header.classList.remove("menu-open");
      body.classList.remove("menu-open");

      [...parentItems].forEach((item) => {
        item.classList.remove("submenu-open");
      });
    });

    window.addEventListener(
      "scroll",
      () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll > 0) {
          header.classList.add("scroll");
        } else {
          header.classList.remove("scroll");
        }
      },
      { passive: true }
    );
  }
}

window.customElements.define("header-component", Header);

class HeroOverlay extends HTMLElement {
  constructor() {
    super();
  }
}

window.customElements.define("hero-overlay-component", HeroOverlay);

class Hero extends HTMLElement {
  constructor() {
    super();

    let anchorLinkContainer = this.querySelector(".anchor-links");

    if (anchorLinkContainer) {
      let main = document.querySelector("#MainContent");
      let headings = main.querySelectorAll("h1, h2");
      let anchorHtml = "";

      [...headings].forEach((heading, index) => {
        if (index == 0) return;
        let url = heading.textContent.replace(/ +/g, "-").toLowerCase();
        heading.id = url;
        anchorHtml += `<a href="#${url}" class="anchor-link">${heading.textContent}</a>`;
      });

      anchorLinkContainer.innerHTML = anchorHtml;

      let anchorLinks = this.querySelectorAll(".anchor-links a");

      [...anchorLinks].forEach((anchorLink) => {
        anchorLink.addEventListener("click", (e) => {
          e.preventDefault();
          let target = e.target.getAttribute("href");
          let offset = document.querySelector(target).offsetTop;
          window.scrollTo({
            top: offset - 200,
            behavior: "smooth",
          });
        });
      });
    }
  }
}

window.customElements.define("hero-component", Hero);

class MainBlog extends HTMLElement {
  constructor() {
    super();

    let cardTitles = this.querySelectorAll(".title");
    let button = this.querySelector(".load-more .button");

    button.addEventListener("click", (e) => {
      e.preventDefault();
      var products_on_page = $(".blog-articles");
      var next_url = products_on_page.data("next-url");

      var load_more_btn = $(".load-more .button");
      var load_more_spinner = $(".load-more_spinner");

      $.ajax({
        url: next_url,
        type: "GET",
        dataType: "html",
        beforeSend: function () {
          load_more_spinner.show();
        },
      }).done(function (next_page) {
        load_more_spinner.hide();

        var new_products = $(next_page).find(".blog-articles");
        var new_url = new_products.data("next-url");

        if (!new_url) load_more_btn.hide();

        next_url = new_url;
        products_on_page.append(new_products.html());
        products_on_page.data("next-url", next_url);
      });
    });
  }
}

window.customElements.define("main-blog", MainBlog);

class MakeEnquiry extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#MakeEnquiry-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setButtonAccessibility();

    const urlParams = new URLSearchParams(window.location.search);
    if (
      urlParams.get("contact[Type]") ||
      window.location.hash === "#ContactForm"
    ) {
      this.open();
    }
  }

  setButtonAccessibility() {
    let $this = this;
    let formMessage = document.querySelectorAll(".form__message");
    const bookLinks = document.querySelectorAll(".make-enquiry");
    [...bookLinks].forEach((bookLink) => {
      bookLink.setAttribute("role", "button");
      bookLink.setAttribute("aria-haspopup", "dialog");
      bookLink.addEventListener("click", (event) => {
        event.preventDefault();
        $this.open(bookLink);
        [...formMessage].forEach((message) => {
          message.style.display = "none";
        });
      });
      bookLink.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          $this.open(bookLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    let span = triggeredBy.querySelector("span");
    let heading = this.querySelector(".drawer__heading");
    heading.innerHTML = span.innerHTML;

    let formType = this.querySelector("#contact-form-type");
    formType.value = span.innerHTML;

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("make-enquiry", MakeEnquiry);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();

    const close = this.querySelectorAll(".close");

    let closedCookie = Cookies.get("newsletter-popup-closed");
    let viewCount = Cookies.get("newsletter-popup-view-count") ?? 0;

    viewCount = parseInt(viewCount) + 1;
    Cookies.set("newsletter-popup-view-count", viewCount, { expires: 7 });

    if (closedCookie === undefined && viewCount >= 3) {
      this.classList.add("visible");
    }

    [...close].forEach((button) => {
      button.addEventListener("click", () => {
        this.classList.remove("visible");
        Cookies.set("newsletter-popup-closed", true, { expires: 7 });
      });
    });
  }
}

window.customElements.define("newsletter-popup", NewsletterPopup);

class PageSidebar extends HTMLElement {
  constructor() {
    super();

    let dropdown = this.querySelector("#care-menu");

    dropdown.addEventListener("change", () => {
      window.location.href = dropdown.value;
    });
  }
}

window.customElements.define("page-sidebar", PageSidebar);

class ProductRange extends HTMLElement {
  constructor() {
    super();

    const swiperEl = this.querySelector(".swiper");
    const breakpoint = window.matchMedia("(min-width:901px)");
    let scrollbar = this.querySelector(".swiper-scrollbar");
    let mySwiper;

    const breakpointChecker = function () {
      // if larger viewport and multi-row layout needed
      if (breakpoint.matches === true) {
        // clean up old instances and inline styles when available
        if (mySwiper !== undefined) mySwiper.destroy(true, true);
        // or/and do nothing
        return;
        // else if a small viewport and single column layout needed
      } else if (breakpoint.matches === false) {
        // fire small viewport version of swiper
        return enableSwiper();
      }
    };

    const enableSwiper = function () {
      mySwiper = new Swiper(swiperEl, {
        slidesPerView: 1.2,
        spaceBetween: 20,
        breakpoints: {
          600: {
            slidesPerView: 2.3,
          },
        },
        scrollbar: {
          el: scrollbar,
        },
      });
    };

    // keep an eye on viewport size changes
    breakpoint.addListener(breakpointChecker);
    // kickstart
    breakpointChecker();
  }
}

window.customElements.define("product-range", ProductRange);

class ProductMediaGallery extends HTMLElement {
  constructor() {
    super();

    const $this = this;

    this.zoomContainer = document.querySelector(".product-media-zoom");
    this.largeContainer = document.querySelector(".product-media-zoom__large");
    this.body = document.querySelector("body");
    $this.setupEvents = this.setupEvents;

    const close = document.querySelector(".product-media-zoom__close");
    close.addEventListener("click", () => {
      $this.zoomContainer.classList.add("hidden");
      $this.body.classList.remove("overflow-hidden");
      $this.body.style.position = "unset";
      $this.largeContainer.innerHTML = "";
    });

    this.setupEvents();
  }

  setupEvents() {
    if (window.innerWidth > 900) {
      const $this = this;
      const media = this.querySelectorAll("img, video");
      const thumbs = document.querySelectorAll(
        ".product-media-zoom__thumbs img, .product-media-zoom__thumbs video"
      );
      const videoThumbs = document.querySelectorAll(
        ".product-media-zoom__thumbs video"
      );

      [...videoThumbs].forEach((item) => {
        item.pause();
      });

      [...media].forEach((item) => {
        item.addEventListener("click", () => {
          $this.zoomContainer.classList.remove("hidden");
          $this.body.classList.add("overflow-hidden");
          $this.body.style.position = "fixed";
          $this.largeContainer.innerHTML = "";

          $this.largeContainer.appendChild(item.cloneNode(true));
        });
      });

      [...thumbs].forEach((item) => {
        item.addEventListener("click", () => {
          $this.largeContainer.innerHTML = "";

          $this.largeContainer.appendChild(item.cloneNode(true));
        });
      });
    } else {
      const firstMobileImageThumb = document.querySelector(
        ".product-media-gallery .product-media-gallery__item:first-child"
      );
      const mobileImageThumbs = document.querySelectorAll(
        ".product-media-gallery .product-media-gallery__item"
      );
      const mobileImageMain = document.querySelector(
        ".product-mobile-main-image"
      );
      const videos = this.querySelectorAll("video");

      [...videos].forEach((item) => {
        item.pause();
      });

      mobileImageMain.innerHTML = "";
      mobileImageMain.appendChild(firstMobileImageThumb.cloneNode(true));

      [...mobileImageThumbs].forEach((item) => {
        item.addEventListener("click", () => {
          mobileImageMain.innerHTML = "";

          mobileImageMain.appendChild(item.cloneNode(true));
        });
      });
    }
  }
}

window.customElements.define("product-media-gallery", ProductMediaGallery);

class Products extends HTMLElement {
  constructor() {
    super();

    this.swiperComponent = this.querySelector(".swiper-component");
    this.swiperEl = this.querySelector(".swiper");
    this.swiper = null;

    if (this.swiperEl) {
      this.initSwiper();
    }
  }

  initSwiper() {
    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: 1.3,
      spaceBetween: 10,
      breakpoints: {
        600: {
          slidesPerView: 2,
        },
        900: {
          slidesPerView: 3,
        },
      },
      navigation: {
        nextEl: this.swiperComponent.querySelector(".swiper-button-next"),
        prevEl: this.swiperComponent.querySelector(".swiper-button-prev"),
      },
      scrollbar: {
        el: this.swiperComponent.querySelector(".swiper-scrollbar"),
        draggable: true,
      },
    });
  }
}

window.customElements.define("products-component", Products);

class RelatedProducts extends HTMLElement {
  constructor() {
    super();

    const url = this.dataset.url;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        if (text) {
          const parsedHTML = new DOMParser().parseFromString(text, "text/html");
          const recommendations = parsedHTML.querySelector(".related-products");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            const swiperEl = this.querySelector(".swiper");
            const swiper = new Swiper(swiperEl, {
              slidesPerView: 1.3,
              spaceBetween: 10,
              breakpoints: {
                600: {
                  slidesPerView: 2,
                },
                1200: {
                  slidesPerView: 3,
                },
              },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
              },
            });
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

window.customElements.define("related-products", RelatedProducts);

class ProductTabs extends HTMLElement {
  constructor() {
    super();

    let $this = this;

    this.buttons = $this.querySelectorAll(".product-tabs__button");
    this.tabs = $this.querySelectorAll(".product-tabs__tab");

    [...this.buttons].forEach((button) => {
      button.addEventListener("click", () => {
        let id = button.dataset.id;

        let tab = $this.querySelector(
          '.product-tabs__tab[data-id="' + id + '"]'
        );

        $this.clearAll();

        button.classList.add("active");
        tab.classList.add("active");
      });
    });
  }

  clearAll() {
    [...this.buttons].forEach((button) => {
      button.classList.remove("active");
    });

    [...this.tabs].forEach((tab) => {
      tab.classList.remove("active");
    });
  }
}

window.customElements.define("product-tabs", ProductTabs);

class TwinImageSlider extends HTMLElement {
  constructor() {
    super();

    const swiperEl = this.querySelector(".swiper");
    let scrollbar = this.querySelector(".swiper-scrollbar");
    let buttonNext = this.querySelector(".swiper-button-next");
    let buttonPrev = this.querySelector(".swiper-button-prev");

    let mySwiper = new Swiper(swiperEl, {
      slidesPerView: 2,
      spaceBetween: 20,
      breakpoints: {
        900: {
          slidesPerView: 1,
        },
        1200: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
      },
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      scrollbar: {
        el: scrollbar,
      },
    });
  }
}

window.customElements.define("twin-image-slider", TwinImageSlider);
